module.exports = __webpack_public_path__ + "img/time_management.ae1f0f79.svg";